var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33292 8.7738e-05H9.30695C9.92338 8.7738e-05 10.426 0.505877 10.426 1.12026V22.7148H1.21826V1.12026C1.21826 0.505877 1.72201 8.7738e-05 2.33292 8.7738e-05Z",
    fill: "#EA7373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4265 4.36799V7.54907L6.05957 5.62197L6.56331 4.42651L10.4265 4.36799Z",
    fill: "#BE5151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3339 -9.53674e-05H2.89066V19.4878H1.21826V1.12023C1.21826 0.505703 1.7221 -9.53674e-05 2.3339 -9.53674e-05Z",
    fill: "#BE5151"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5572 16.7039H11.0874C11.391 16.7039 11.6446 16.9547 11.6446 17.264V22.7148H0V17.264C0 16.9547 0.250237 16.7039 0.5572 16.7039Z",
    fill: "#3B4347"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21826 16.7036H10.426V15.182L1.21826 13.0293V16.7036Z",
    fill: "#BE5151"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22.7148H11.6446V20.3031H0V22.7148Z",
    fill: "#2E353A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82285 2.35738C6.97527 2.35738 7.90658 3.2937 7.90658 4.45163C7.90658 5.60956 6.97527 6.55005 5.82285 6.55005C4.67151 6.55005 3.73584 5.60956 3.73584 4.45163C3.73584 3.2937 4.67151 2.35738 5.82285 2.35738Z",
    fill: "#2C2B2A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2711 3.26456H33.8186C34.4714 3.26456 35 3.79963 35 4.4518C35 5.10801 34.4714 5.64307 33.8186 5.64307H6.2711C5.61826 5.64307 5.08594 5.10801 5.08594 4.4518C5.08594 3.79963 5.61826 3.26456 6.2711 3.26456Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 4.4518C35 5.10801 34.4714 5.64307 33.8186 5.64307H6.2711C5.61826 5.64307 5.08594 5.10801 5.08594 4.4518H35Z",
    fill: "#EEEDED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0703 3.26459C13.2406 4.05879 13.412 4.84876 13.5868 5.64307C14.1804 5.64307 14.7797 5.64307 15.3745 5.64307C15.2042 4.84876 15.034 4.05879 14.8626 3.26459C14.2644 3.26459 13.6696 3.26459 13.0703 3.26459Z",
    fill: "#E96666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6543 3.26457L9.17061 5.64307H10.9589L10.447 3.26457H8.6543Z",
    fill: "#E96666"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4873 3.26458C17.6581 4.05881 17.829 4.84884 17.9998 5.64307C18.5983 5.64307 19.1968 5.64307 19.7919 5.64307C19.621 4.84884 19.4514 4.05881 19.2805 3.26458C18.682 3.26458 18.087 3.26458 17.4873 3.26458Z",
    fill: "#E96666"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3203 3.26457C26.4906 4.05879 26.6609 4.84885 26.8312 5.64307C27.4308 5.64307 28.0293 5.64307 28.6241 5.64307C28.4538 4.84885 28.2835 4.05879 28.1132 3.26457C27.5136 3.26457 26.9188 3.26457 26.3203 3.26457Z",
    fill: "#E96666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9043 3.26459C22.0744 4.05881 22.2444 4.84885 22.4157 5.64307C23.0139 5.64307 23.6133 5.64307 24.2079 5.64307C24.0366 4.84885 23.8666 4.05881 23.6965 3.26459C23.0971 3.26459 22.5025 3.26459 21.9043 3.26459Z",
    fill: "#E96666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5299 3.26458H30.7368L31.2491 5.64307H33.0409L32.5299 3.26458Z",
    fill: "#E96666"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3286 4.45172L13.5874 5.64307C14.181 5.64307 14.7804 5.64307 15.3751 5.64307L15.122 4.45172H13.3286Z",
    fill: "#CB2C31"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7446 4.45178L17.9991 5.64307C18.5977 5.64307 19.1962 5.64307 19.7912 5.64307L19.5378 4.45178H17.7446Z",
    fill: "#CB2C31"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91162 4.45175L9.16978 5.64307H10.9581L10.7043 4.45175H8.91162Z",
    fill: "#CB2C31"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1631 4.45174L22.4164 5.64307C23.0146 5.64307 23.614 5.64307 24.2086 5.64307L23.9553 4.45174H22.1631Z",
    fill: "#CB2C31"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5781 4.45174L26.8311 5.64307C27.4308 5.64307 28.0292 5.64307 28.624 5.64307L28.3662 4.45174H26.5781Z",
    fill: "#CB2C31"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7832 4.4517H30.9951L31.2488 5.64307H33.0406L32.7832 4.4517Z",
    fill: "#CB2C31"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToll);
export default __webpack_public_path__ + "static/media/toll.f25d0353c546b732ddc16991793d562e.svg";
export { ForwardRef as ReactComponent };